import { useEffect, useState } from 'react';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import './Tamil.scss';
import CalenderLinks from '../../../components/CalanderLinks/CalanderLinks';
import axios from 'axios';

const Tamil = () => {
  // Step 1: Track which months are expanded
  const [expandedMonths, setExpandedMonths] = useState({});

  // Step 2: Toggle expand/collapse for a month
  const handleToggle = (index) => {
    setExpandedMonths((prev) => ({
      ...prev,
      [index]: !prev[index], // flip true/false
    }));
  };





   const [allMonths, setAllMonths] = useState([]);

 const currentYear = new Date().getFullYear();
const [year, setYear] = useState(currentYear);

  // temporary values (for input fields)
const [tempYear, setTempYear] = useState(currentYear);

  useEffect(() => {
    const fetchTamilFestivals = async () => {
      try {
        const res = await axios.get(
          `https://core-c343.onrender.com/api/tamil-region?year=${year}`
        );
        const festivalsData = res.data?.months || {};

        // Convert the object into an array like [{month: 'March', festivals: [...]}, ...]
        const monthWiseList = Object.entries(festivalsData).map(([month, festivals]) => ({
          month: `${month}, ${year}`,
          festivals: festivals.map(f => ({
            name: f.name,
            date: new Date(f.date).toDateString(), // Convert to readable format
            info: f.calendar, // No info in API; you can add if needed
          })),
        }));

        setAllMonths(monthWiseList);
      } catch (error) {
        console.error('Failed to fetch Tamil festival data:', error);
      }
    };

    fetchTamilFestivals();
  }, [year]);


  const handleSubmit = () => {
  setYear(tempYear);
};



  // Step 4: Render the content
  return (
    <div className="Tamil-container">
      <InnerNav />
      <div className="Tamil-content">
        <div className="year-selector">
        <label htmlFor="year">Select Year: </label>
        <input
          id="year"
          type="number"
          min="1900"
          max="2100"
          value={tempYear}
          onChange={(e) => setTempYear(Number(e.target.value))}
        />
        <button className="submit" onClick={handleSubmit}>Submit</button>
      </div>
        <h1>Tamil Festivals</h1>
        {allMonths.map((month, index) => {
          // check if this month is expanded
          const isExpanded = expandedMonths[index];
          // show only first 2 if not expanded
          const visibleFestivals = isExpanded
            ? month.festivals
            : month.festivals.slice(0, 2);

          return (
            <div className="monthFestivals" key={index}>
              <h2>{month.month}</h2>
              <div className="list-Of-festivals">
                {visibleFestivals.map((fest, i) => (
                  <div key={i}>
                    <div className="image">
                      <img src="https://www.atlastravel.in/wp-content/uploads/2022/05/festivals-of-tamil-nadu-2.webp" alt="Festival Icon" />
                    </div>
                    <div className="info">
                      <p>{fest.name}</p>
                      <p>{fest.date}</p>
                      <p>{fest.info}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Only show button if more than 2 festivals */}
              {month.festivals.length > 2 && (
                <button onClick={() => handleToggle(index)}>
                  {isExpanded ? 'Show less' : 'More festivals'}
                </button>
              )}
            </div>
          );
        })}
        <CalenderLinks/>
      </div>
      <Footer />
    </div>
  );
};

export default Tamil;
